import { Field, reduxForm } from 'redux-form'
import React, { Component, PropTypes } from 'react'
import InputField from 'client/features/form/components/InputField.jsx'
import CheckboxField from 'client/features/form/components/CheckboxField.jsx'
import { connect } from 'react-redux'
import FontAwesome from 'react-fontawesome'

const validate = values => {
    const errors = {}
    if (!values.name) errors.name = 'Name required'
    return errors
}

class Hive extends Component {
    constructor() {
        super()
        this.onChange = this.onChange.bind(this)
        this.submit = this.submit.bind(this)
        this.state = {
            lastChange: null
        }
    }

    onChange() {
        const now = new Date().getTime()
        this.setState({ lastChange: now })
        setTimeout(() => this.state.lastChange && this.state.lastChange === now ? this.submit() : null, 1000)
    }

    submit() {
        this.setState({ lastChange: null })
        this.props.submit()
    }

    render() {
        const { handleSubmit, initialValues, hive } = this.props
        if (hive.deleted)
            return <tr></tr>
        return (
            <tr>
                <td>
                    <Field name='identifier' component={ InputField } type='text' placeholder='Id...' className='content-editable' containerClassName='ce' divClass='ce' autocomplete='off'/>
                </td>
                <td>
                    <Field name='active' component={ CheckboxField } initialValues={ initialValues.active } boolean={ true } />
                </td>
                <td>
                    { hive.state === 'dead' && <span><FontAwesome name='warning' /> </span> }
                </td>
                <td className='text-right'>
                    <a className='btn btn-success btn-xs waves-effect' onClick={ handleSubmit } disabled={ this.props.pristine }>
                        Sauver
                    </a>
                </td>
                <td className='text-right'>
                    <a className='btn btn-danger btn-xs waves-effect' onClick={ this.props.deleteHive.bind(null, this.props.hive) }>
                        Supprimer
                    </a>
                </td>
            </tr>
        )
    }
}

Hive = reduxForm({
    form: `hive-${Math.random().toString(36).substring(7)}`,
    validate
})(Hive)

const mapStateToProps = (state, ownProps) => {
    return {
        form: ownProps.name
    }
}

export default connect(mapStateToProps)(Hive)


// WEBPACK FOOTER //
// ./src/client/features/client/components/Hive.jsx